import { useState } from "react";
import { Container, ExtraExplain, NavWrapper, TitleWrapper, Wrapper } from "./style";
import Nav from "../Nav";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com2 = ({ menu, menuData }) => {
  const [isOpen, setIsOpen] = useState([]);
  const clickHandler = (index) => {
    const temp = isOpen;
    temp[index] = !temp[index];
    setIsOpen([...temp]);
  };

  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      <NavWrapper>
        {/* nav 컴포넌트 */}
        <Nav menu={menu} />
      </NavWrapper>
      <Container>
        {menuData.data.map((v, idx) => (
          <div key={v.id}>
            <TitleWrapper onClick={() => clickHandler(idx)}>
              <span>{language === "en" ? v.title : v.titleKR}</span>
              {isOpen[idx] ? (
                <img loading="lazy" src="/assets/img/Support_12.svg" alt="" />
              ) : (
                <img loading="lazy" src="/assets/img/Support_11.svg" alt="" />
              )}
            </TitleWrapper>
            <ExtraExplain isOpen={isOpen[idx]}>{language === "en" ? v.content : v.contentKR}</ExtraExplain>
          </div>
        ))}
      </Container>
    </Wrapper>
  );
};

export default Com2;
